import Image from "next/image";

export default function DownloadGoogleIcon() {
  return (
    <Image src='/images/home/download_google.svg' alt='Google Play' width={189} height={57} />
  );
};